<div>
  <mat-icon *ngIf="!isAudioEnabled" class="icon"> mic_off</mat-icon>
  <mat-icon *ngIf="!isVideoEnabled" class="icon"> videocam_off</mat-icon>
</div>
